import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom';
import './index.css'
import App from './App.jsx'
import { authReady } from './firebase.js'
import { ThemeProvider } from './theme'
import { countPlay } from './Services/playCounter'
import { markTestSession } from './utils/testSession'

// Dev-only, opt-in via ?freshSession=1: this app stores player identity
// (currentUserId, playerName, currentRoomId, isHost, etc.) directly in
// localStorage all over the codebase, not just via Firebase Auth's own
// persistence — so setting Firebase to session-only persistence alone
// isn't enough to make two browser tabs act as two different players,
// since localStorage itself is shared across every tab of the same origin.
// Redirecting window.localStorage to window.sessionStorage here, before
// anything else in the app runs, makes every one of those call sites
// naturally become per-tab without touching each one individually. Must
// run before src/firebase.js's own freshSession check and before App
// mounts. Never runs outside DEV and never without the query flag, so
// production and normal local dev are untouched.
if (import.meta.env.DEV && new URLSearchParams(window.location.search).has('freshSession')) {
  try {
    Object.defineProperty(window, 'localStorage', {
      value: window.sessionStorage,
      configurable: true,
    });
    console.log('[dev] freshSession: localStorage redirected to sessionStorage for this tab');
  } catch (err) {
    console.warn('[dev] Failed to redirect localStorage for freshSession:', err);
  }
}

markTestSession();

// One anonymous play count for the Naija Indie listing; local development doesn't count.
if (import.meta.env.PROD) countPlay();

// Auth persistence (see firebase.js) must be settled before any component
// can call signInAnonymously, or the freshSession dev flag above is a no-op.
authReady.then(() => {
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </StrictMode>,
  )
})
